/**
 * SubscriptionModal — shows Pro plan benefits and triggers Stripe subscription checkout.
 */

import { useCreditsStore } from '../store/creditsStore';

interface Props {
  onClose: () => void;
}

const BENEFITS = [
  { icon: '🧠', text: 'Deep Analysis — investor-grade AI reports' },
  { icon: '⚡', text: '100 credits every month, auto-renewed' },
  { icon: '🆓', text: 'Pipeline steps don\'t cost credits' },
  { icon: '🚀', text: 'Priority AI processing' },
  { icon: '📄', text: 'PDF export for all reports' },
  { icon: '🎯', text: 'Early access to new features' },
];

export default function SubscriptionModal({ onClose }: Props) {
  const { subscribe, manage } = useCreditsStore();

  const handleSubscribe = async () => {
    try {
      await subscribe();
    } catch {
      // subscribe redirects to Stripe
    }
  };

  const openPortal = async () => {
    try {
      await manage();
    } catch {
      // manage redirects to Stripe portal
    }
  };

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 9999,
        background: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(6px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 20,
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: '#0d0d1f',
          border: '1px solid rgba(249,115,22,0.3)',
          borderRadius: 24, padding: '40px 36px', maxWidth: 440, width: '100%',
          boxShadow: '0 0 60px rgba(249,115,22,0.1)',
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <h2 style={{ fontSize: 24, fontWeight: 800, color: '#fff', marginBottom: 4 }}>
            Upgrade to StartupScore Pro
          </h2>
          <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'center', gap: 4, marginBottom: 4 }}>
            <span style={{ fontSize: 36, fontWeight: 900, color: '#f97316' }}>$29</span>
            <span style={{ fontSize: 14, color: '#6b7280' }}>/ month</span>
          </div>
          <p style={{ fontSize: 13, color: '#6b7280' }}>Cancel anytime</p>
        </div>

        <div style={{ marginBottom: 28 }}>
          {BENEFITS.map((b, i) => (
            <div key={i} style={{
              display: 'flex', alignItems: 'center', gap: 12,
              padding: '10px 0',
              borderBottom: i < BENEFITS.length - 1 ? '1px solid rgba(255,255,255,0.06)' : undefined,
            }}>
              <span style={{ fontSize: 18, flexShrink: 0 }}>{b.icon}</span>
              <span style={{ fontSize: 14, color: '#d1d5db' }}>{b.text}</span>
            </div>
          ))}
        </div>

        <button
          onClick={handleSubscribe}
          style={{
            width: '100%', padding: '14px 0', borderRadius: 14,
            background: 'linear-gradient(135deg, #f97316, #ea580c)',
            border: 'none', color: '#fff', fontSize: 16, fontWeight: 700,
            cursor: 'pointer', boxShadow: '0 4px 18px rgba(249,115,22,0.35)',
          }}
        >
          → Upgrade to Pro — $29/month
        </button>

        <button
          onClick={onClose}
          style={{
            display: 'block', margin: '16px auto 0', background: 'transparent',
            border: 'none', color: '#6b7280', fontSize: 13, cursor: 'pointer',
          }}
        >
          Maybe later
        </button>

        <p style={{ textAlign: 'center', marginTop: 16, fontSize: 12, color: '#4b5563' }}>
          Already subscribed? <button onClick={openPortal} style={{ background: 'none', border: 'none', color: '#7c6ff7', cursor: 'pointer', fontSize: 12, textDecoration: 'underline' }}>Manage subscription →</button>
        </p>
      </div>
    </div>
  );
}
